/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { RequestConfig, ResponseErrorConfig } from '../.kubb/client'
import type {
  LeverageGetAccruedInterestByUserOptions,
  LeverageGetAccruedInterestByUserStatus200,
  LeverageGetAccruedInterestByUserStatus400,
  LeverageGetAccruedInterestByUserStatus401,
  LeverageGetAccruedInterestByUserStatus500,
} from '../types/LeverageGetAccruedInterestByUser'
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from '@tanstack/react-query'
import { leverageGetAccruedInterestByUser } from '../clients/leverageGetAccruedInterestByUser'
import { queryOptions, useQuery } from '@tanstack/react-query'

export const leverageGetAccruedInterestByUserQueryKey = ({
  path,
  query,
}: Omit<LeverageGetAccruedInterestByUserOptions, 'headers'>) =>
  [
    { url: '/v1/leverage/accrued_interest/:user_id', params: path },
    ...(query ? [query] : []),
  ] as const

type LeverageGetAccruedInterestByUserQueryKey = ReturnType<
  typeof leverageGetAccruedInterestByUserQueryKey
>

export function leverageGetAccruedInterestByUserQueryOptions(
  { path, query }: LeverageGetAccruedInterestByUserOptions,
  config: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>> = {},
) {
  const queryKey = leverageGetAccruedInterestByUserQueryKey({ path, query })
  return queryOptions<
    LeverageGetAccruedInterestByUserStatus200,
    ResponseErrorConfig<
      | LeverageGetAccruedInterestByUserStatus400
      | LeverageGetAccruedInterestByUserStatus401
      | LeverageGetAccruedInterestByUserStatus500
    >,
    LeverageGetAccruedInterestByUserStatus200,
    typeof queryKey
  >({
    queryKey,
    queryFn: async ({ signal }) => {
      return leverageGetAccruedInterestByUser({
        ...config,
        path,
        query,
        signal: config.signal ?? signal,
        throwOnError: true,
      }).unwrap()
    },
  })
}

/**
 * @summary Get current accrued leverage interest for a specific user
 * {@link /v1/leverage/accrued_interest/:user_id}
 */
export function useLeverageGetAccruedInterestByUser<
  TData = LeverageGetAccruedInterestByUserStatus200,
  TQueryData = LeverageGetAccruedInterestByUserStatus200,
  TQueryKey extends QueryKey = LeverageGetAccruedInterestByUserQueryKey,
>(
  {
    path,
    query,
  }: {
    path:
      | LeverageGetAccruedInterestByUserOptions['path']
      | (() => LeverageGetAccruedInterestByUserOptions['path'])
    query?:
      | LeverageGetAccruedInterestByUserOptions['query']
      | (() => LeverageGetAccruedInterestByUserOptions['query'])
  },
  options: {
    query?: Partial<
      QueryObserverOptions<
        LeverageGetAccruedInterestByUserStatus200,
        ResponseErrorConfig<
          | LeverageGetAccruedInterestByUserStatus400
          | LeverageGetAccruedInterestByUserStatus401
          | LeverageGetAccruedInterestByUserStatus500
        >,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient }
    client?: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>>
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...resolvedOptions } = queryConfig
  const resolvedParams = {
    path: typeof path === 'function' ? path() : path,
    query: typeof query === 'function' ? query() : query,
  }
  const queryKey =
    resolvedOptions?.queryKey ?? leverageGetAccruedInterestByUserQueryKey(resolvedParams)

  const queryResult = useQuery(
    {
      ...leverageGetAccruedInterestByUserQueryOptions(resolvedParams, config),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<
    TData,
    ResponseErrorConfig<
      | LeverageGetAccruedInterestByUserStatus400
      | LeverageGetAccruedInterestByUserStatus401
      | LeverageGetAccruedInterestByUserStatus500
    >
  > & { queryKey: TQueryKey }

  queryResult.queryKey = queryKey as TQueryKey

  return queryResult
}
